export class AdvancePaymentDetails {
    advancePaymentId: number;
    stationId: number;
    accountExecutiveId: number;
    externalUserComments: string;
    totalAmount: number;
    createdBy: number;
    //Arvind
    agencyAdvance: number;
    //Arvind for adding Agency commision on db
    agencyCommission: number;  
    agencycomm : number;
    taxpercent : number;
    advanceTax : number;
    tax : number;

}



// WEBPACK FOOTER //
// ./src/app/external-user/Model/AdvancePaymentDetails.ts